import { render, staticRenderFns } from "./CatalogueWrapper.vue?vue&type=template&id=9a91b460&"
import script from "./CatalogueWrapper.vue?vue&type=script&lang=js&"
export * from "./CatalogueWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports